fragment ContentBlocksCardSlider on contentBlocks_cardSlider_BlockType {
    sectionTitle
    sectionDescription

    contentOverview {
        manualOrAutomatic

        manuallySelectedEntries {
            id
            slug
            uri

            ... on default_Entry {
                ... DefaultCard
            }

            ... on detail_Entry {
                ... DetailCard
            }
        }

        sections
        limit

        entriesRelatedTo {
            id
        }

        entriesNotRelatedTo {
            id
        }
    }

    cta {
        ... CraftLink
    }

    showShape

    anchorId
    anchorLabel
}
